<template>
  <div class="reward-form">
    <el-form :model="model" :rules="rules" ref="form">
      <el-form-item prop="accountUserName">
        <el-input v-model="model.accountUserName" placeholder="姓名"></el-input>
      </el-form-item>
      <el-form-item prop="accountUserPhone">
        <el-input v-model="model.accountUserPhone" placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item prop="accountUserExtraInfo" v-if="isNeedExpress" :rules="addressRules">
        <el-input v-model="model.accountUserExtraInfo" placeholder="详细地址"></el-input>
      </el-form-item>
      <el-form-item prop="accountUserExtraInfo" v-else-if="!isCoupon && extraInfo" :rules="infoRules">
        <el-input v-model="model.accountUserExtraInfo" :placeholder="extraInfo"></el-input>
      </el-form-item>
    </el-form>
    <div>
      <el-button @click="onReceive" class="w-full" type="danger">领取</el-button>
    </div>
    <div class="text-small text-center mt-2">
      <p>信息填写不正确会影响接收奖品</p>
      <p>请在 15 分钟内提交获奖信息，逾期无法领取</p>
      <p>如对奖品有疑问，请联系发布人</p>
    </div>
  </div>
</template>

<script>
import { ValidateRule } from 'dygc'

export default {
  name: 'RewardForm',
  data() {
    const createRequiredValidator = function (message) {
      return function (rule, val, cb) {
        if (!val.trim()) {
          cb(new Error(message))
        } else {
          cb()
        }
      }
    }

    const phoneValidator = function (rule, val, cb) {
      if (ValidateRule.phone(val.trim())) {
        cb()
      } else {
        cb(new Error('手机号码格式错误，请重新输入'))
      }
    }
    return {
      model: {
        accountUserName: '',
        accountUserPhone: '',
        accountUserExtraInfo: ''
      },
      rules: {
        accountUserName: [{ validator: createRequiredValidator('姓名不能为空'), trigger: 'blur' }],
        accountUserPhone: [
          { validator: createRequiredValidator('手机号不能为空'), trigger: 'blur' },
          { validator: phoneValidator, trigger: 'blur' }
        ]
      },
      addressRules:[{ validator: createRequiredValidator('详细地址不能为空'), trigger: 'blur' }],
      infoRules:[{ validator: createRequiredValidator('附加信息不能为空'), trigger: 'blur' }]
    }
  },
  methods: {
    onReceive() {
      this.validate().then(isOk=>{
        if(!isOk) return
        this.$bus.receiveAward(this.model)
      })
    },
    validate() {
      return new Promise(resolve => {
        this.$refs.form.validate(resolve)
      })
    }
  },
  computed:{
    isNeedExpress() {
      return this.$bus.currentAwardData?.bindAward?.lotteryCategory === 1
    },
    isCoupon(){
      return this.$bus.currentAwardData?.bindAward?.lotteryCategory === 3
    },
    extraInfo(){
      return this.$bus.currentAwardData?.bindAward?.extraInfo
    }
  }
}
</script>

<style scoped></style>
